<template>
  <div>
    <div class="field-title">Show/Hide Search Result Columns</div>
    <div class="search-result-fields">
      <div v-for="(item, idx) in fieldList" :key="idx" class="field">
        <Checkbox size="tiny" :checked="toggleFields.includes(item)" @change="onChange(item)" />
        <label class="field-label">{{ item }}</label>
      </div>
    </div>
  </div>
</template>

<script>
import Checkbox from '@/app/components/Checkbox.vue';

export default {
  components: {
    Checkbox
  },
  props: {
    fieldList: {
      type: Array,
      default: () => []
    },
    displayFields: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      toggleFields: [...this.displayFields]
    };
  },
  methods: {
    onChange(field) {
      let pos = this.toggleFields.indexOf(field);
      let emitFunc;
      if (pos >= 0) {
        this.toggleFields = this.toggleFields.filter(f => f !== field);
        emitFunc = 'removed';
      } else {
        this.toggleFields.push(field);
        emitFunc = 'selected';
      }
      this.$emit(emitFunc, { field });
    }
  }
};
</script>

<style scoped lang="scss">
@import '@/app/styles/colors';
@import '@/app/styles/variables';
.field-title {
  background-color: $white;
  padding: 12px 5px;
  border-bottom: 1px solid $row-border;
  font-weight: bold;
}
.search-result-fields {
  display: flex;
  flex-wrap: wrap;
  background-color: $white;

  padding: 12px 5px;
  margin-left: auto;
  .field {
    .field-label {
      display: flex;
      align-items: center;
      display: inline-block;
      width: 250px;
    }
  }
}
</style>
